import {URL_BASE_API } from '../../../configs/urlConfigs';
import {LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP} from '../../../configs/staticConfigs';

import service from '../../api';

let userGroup = ''; 

export const clientCategoryMasterList = (request) => {
    let ENDPOINT = URL_BASE_API+'super-admin/client-category-master/';
    if(request.data!==undefined && request?.data?.column) { 
      ENDPOINT += '?column='+request.data.column; 
    }
    return service.get(ENDPOINT);
};


export const clientCategoryMasterAdd = (request) => {
  let ENDPOINT = URL_BASE_API+'super-admin/client-category-master/';
  return service.post(ENDPOINT,request.data);
};

export const clientCategoryMasterEdit = (request) => {
  let clientCategoryId = request.data;
  let ENDPOINT = URL_BASE_API+'super-admin/client-category-master/'+clientCategoryId;
  return service.get(ENDPOINT);  
};


export const clientCategoryMasterUpdate = (request) => {
  let clientCategoryId = request.data.id;
  let ENDPOINT = URL_BASE_API+'super-admin/client-category-master/'+clientCategoryId;
  return service.put(ENDPOINT,request.data);  
};

export const clientCategoryMasterDelete = (request) => {
  let ENDPOINT = URL_BASE_API+'super-admin/client-category-master/'+request.data;
  return service.delete(ENDPOINT);   
};  